import React from "react";
import moment from "moment";
import { Label, FormGroup } from "reactstrap";
import firebase from "../../../Firebase.js";
import {
  Modal,
  notification,
  message,
  Button,
  Input,
  Upload,
  Icon,
  Alert,
} from "antd";
import "antd/dist/antd.css";
import {
  validateCorteQuantities,
  computeCorteEstado,
  computeCorteTotal,
  shouldCreateCostura,
} from "../../../utils/corteValidation";
import {
  normalizeFiles,
  haySubidaEnCurso,
  aFileList,
  aCampos,
} from "../../../utils/fileList";

class CorteRegistroModal extends React.Component {
  constructor(props) {
    super(props);
    this.ref = firebase.firestore().collection("corte");
    this.storageRef = firebase.storage();
    this.state = this.buildInitialState(props);
  }

  buildInitialState(props) {
    return {
      cantidad: props.cantidad1 || "",
      cantidad2: props.cantidad2 || "",
      servicio: props.servicio || "TexCross",
      completado: props.estado === "Listo",
      filelistTizado: aFileList(
        normalizeFiles(props.tizadoUrl, props.tizadoName)
      ),
      uploading: false,
      isActive: false,
      auxDataLoading: true,
      comercialId: null,
      comercialIndex: null,
      lastCosturaId: null,
      cliente: "",
    };
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.loadAuxData();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState(this.buildInitialState(this.props));
      this.loadAuxData();
    }
  }

  loadAuxData = () => {
    const { op, color } = this.props;

    const costuraPromise = firebase
      .firestore()
      .collection("costura")
      .orderBy("order", "desc")
      .limit(1)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.setState({ lastCosturaId: doc.data().index });
        });
      });

    const ingPromise = firebase
      .firestore()
      .collection("ing")
      .where("op", "==", op)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.setState({ cliente: doc.data().cliente });
        });
      });

    const comercialPromise = firebase
      .firestore()
      .collection("comercial")
      .where("op", "==", op)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.setState({
            comercialIndex: doc
              .data()
              .otros.map((v) => v.color)
              .indexOf(color),
            comercialId: doc.id,
          });
        });
      });

    Promise.all([costuraPromise, ingPromise, comercialPromise])
      .then(() => {
        this.setState({ auxDataLoading: false });
      })
      .catch((error) => {
        console.error("Error cargando datos del registro: ", error);
        notification.error({
          message:
            "No se pudieron cargar todos los datos de este registro. Cierra y vuelve a abrirlo antes de guardar.",
          top: 80,
        });
        this.setState({ auxDataLoading: false });
      });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  toggleCompletado = () => {
    this.setState((prev) => ({ completado: !prev.completado }));
  };

  handleChangeTizado = (info) => {
    this.setState({ filelistTizado: info.fileList });
  };

  customUploadTizado = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const storager = await this.storageRef.ref();
    const nombre = `${Date.now()}-${file.name}`;
    const tizadoFile = storager.child(`tizados/${nombre}`);

    try {
      const uploadTask = await tizadoFile.put(file);
      const url = await this.storageRef
        .ref("tizados")
        .child(nombre)
        .getDownloadURL();
      this.setState({ uploading: false });
      onSuccess(null, { ...uploadTask, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const {
      cantidad,
      cantidad2,
      servicio,
      completado,
      comercialId,
      comercialIndex,
      lastCosturaId,
      cliente,
    } = this.state;

    const tizadoFiles = aCampos(this.state.filelistTizado);
    const tizadoName = tizadoFiles.map((f) => f.name).join(", ");
    const {
      docId,
      op,
      color,
      fechaCorte1,
      fechaIngreso2,
      onSaved,
      onClose,
    } = this.props;

    const validation = validateCorteQuantities({ cantidad1: cantidad, cantidad2 });
    if (!validation.valid) {
      notification.error({ message: validation.message, top: 80 });
      return;
    }

    this.setState({ isActive: true });
    message.loading("Guardando...", 60);

    const today = moment().format("DD/MM/YYYY");
    const nuevaFechaCorte1 = fechaCorte1 || (Number(cantidad) > 0 ? today : "");
    const nuevaFechaCorte2 = fechaIngreso2 || (Number(cantidad2) > 0 ? today : "");
    const total = computeCorteTotal({ cantidad1: cantidad, cantidad2 });
    const estadoNuevo = computeCorteEstado({ completado });

    this.ref
      .doc(String(docId))
      .get()
      .then((res) => {
        const corte = res.data();
        if (!corte || !Array.isArray(corte.otros) || !Array.isArray(corte.estado)) {
          throw new Error("No se encontró el registro de corte o tiene un formato inválido.");
        }
        const isFirstSave = corte.otros.length === 0;
        const estadoPrevio = corte.estado[0];

        const entry = {
          ...(corte.otros[0] || {}),
          fechaIngreso: nuevaFechaCorte1,
          cantidad: Number(cantidad),
          fechaIngreso2: nuevaFechaCorte2,
          cantidad2: Number(cantidad2) || 0,
          servicio,
          total,
          tizadoUrl: tizadoFiles,
          tizadoName,
        };

        if (isFirstSave) {
          corte.otros.push(entry);
          corte.isEditable = true;
        } else {
          corte.otros[0] = entry;
        }
        corte.estado[0] = estadoNuevo;

        const needsCosturaRecord = shouldCreateCostura({ estadoPrevio, estadoNuevo });

        const writes = [this.ref.doc(String(docId)).update(corte)];

        if (comercialId) {
          writes.push(
            firebase
              .firestore()
              .collection("comercial")
              .doc(comercialId)
              .get()
              .then((doc) => {
                let otros = doc.data().otros;
                otros[comercialIndex] = {
                  ...otros[comercialIndex],
                  corte: {
                    fechaIngreso: nuevaFechaCorte1,
                    cantidad: Number(cantidad),
                    fechaIngreso2: nuevaFechaCorte2,
                    cantidad2: Number(cantidad2) || 0,
                    servicio,
                    total,
                  },
                };
                return firebase
                  .firestore()
                  .collection("comercial")
                  .doc(comercialId)
                  .set({ otros }, { merge: true });
              })
          );
        }

        if (isFirstSave) {
          writes.push(
            firebase
              .firestore()
              .collection("ing")
              .where("op", "==", op)
              .get()
              .then((querySnapshot) => {
                const updates = [];
                querySnapshot.forEach((doc) => {
                  let otros = doc.data().otros;
                  otros.forEach((item) => {
                    if (item.color === color) {
                      item.status = ["Corte"];
                    }
                  });
                  updates.push(
                    firebase
                      .firestore()
                      .collection("ing")
                      .doc(doc.id)
                      .set({ otros }, { merge: true })
                  );
                });
                return Promise.all(updates);
              })
          );
        }

        if (isFirstSave) {
          writes.push(
            firebase
              .firestore()
              .collection("telas")
              .where("op", "==", op)
              .where("color", "==", color)
              .get()
              .then((qs) => {
                const updates = [];
                qs.forEach((doc) => {
                  updates.push(
                    firebase
                      .firestore()
                      .collection("telas")
                      .doc(doc.id)
                      .update({ isEditable: false })
                  );
                });
                return Promise.all(updates);
              })
          );
        }

        if (needsCosturaRecord) {
          const id = Number(lastCosturaId) + 1;
          const costura = {
            b: corte.b ? corte.b : "",
            cantCorte: total,
            cliente,
            color: corte.color,
            corteFechaIngreso: nuevaFechaCorte2 || nuevaFechaCorte1,
            cx: corte.cx,
            descripcion: corte.descripcion,
            entrega: "",
            edit: [String(id), corte.op, corte.color, "Nuevo"],
            estado: ["Nuevo", corte.op, corte.color],
            ft: corte.ft ? corte.ft : "",
            index: String(id),
            op: corte.op,
            order: Number(id),
            otros: [],
            isEditable: true,
          };
          writes.push(
            firebase.firestore().collection("costura").doc(String(id)).set(costura)
          );
        }

        Promise.all(writes)
          .then(() => {
            message.destroy();
            notification.success({ message: "Registro guardado correctamente.", top: 80 });
            this.setState({ isActive: false });
            onSaved();
            onClose();
          })
          .catch((error) => {
            message.destroy();
            console.error("Error guardando corte: ", error);
            notification.error({ message: "Ocurrió un error al guardar.", top: 80 });
            this.setState({ isActive: false });
          });
      })
      .catch((error) => {
        message.destroy();
        console.error("Error leyendo el registro de corte: ", error);
        notification.error({
          message: "No se pudo leer el registro de corte. Cierra el modal e inténtalo de nuevo.",
          top: 80,
        });
        this.setState({ isActive: false });
      });
  };

  render() {
    const { isOpen, onClose, op, color, cantidadPCP } = this.props;
    const {
      cantidad,
      cantidad2,
      servicio,
      completado,
      filelistTizado,
      uploading,
      isActive,
      auxDataLoading,
    } = this.state;

    return (
      <Modal
        title="Registro de Corte"
        visible={isOpen}
        onCancel={onClose}
        centered
        width={480}
        footer={[
          <Button key="cancel" onClick={onClose}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={auxDataLoading}
            onClick={this.onSubmit}
            disabled={
              isActive ||
              !cantidad ||
              uploading ||
              haySubidaEnCurso(filelistTizado) ||
              auxDataLoading
            }
            style={
              completado
                ? { backgroundColor: "#219653", borderColor: "#219653" }
                : undefined
            }
          >
            {auxDataLoading
              ? "Cargando..."
              : completado
              ? "Guardar y marcar Listo"
              : "Guardar"}
          </Button>,
        ]}
        destroyOnClose
      >
        <form>
          <FormGroup>
            <Label className="font-weight-bold">ORDEN DE PRODUCCIÓN</Label>
            <Input className="col-md-8 d-block" value={op} disabled />
          </FormGroup>
          <FormGroup>
            <Label className="font-weight-bold">COLOR</Label>
            <Input className="col-md-8 d-block" value={color} disabled />
          </FormGroup>
          <FormGroup>
            <Label className="font-weight-bold">CANTIDAD PCP</Label>
            <Input className="col-md-4 d-block" value={cantidadPCP} disabled />
          </FormGroup>
          <FormGroup>
            <Label className="font-weight-bold">SERVICIO</Label>
            <Input
              name="servicio"
              className="col-md-4 d-block"
              value={servicio}
              onChange={this.onChange}
              autoComplete="off"
            />
          </FormGroup>

          <hr />
          <Label className="font-weight-bold d-block">CORTE 1</Label>
          <FormGroup>
            <Label>Cantidad</Label>
            <Input
              name="cantidad"
              className="col-md-4 d-block"
              value={cantidad}
              onChange={this.onChange}
              autoComplete="off"
            />
          </FormGroup>

          <hr />
          <Label className="font-weight-bold d-block">CORTE 2</Label>
          <FormGroup>
            <Label>Cantidad</Label>
            <Input
              name="cantidad2"
              className="col-md-4 d-block"
              value={cantidad2}
              onChange={this.onChange}
              autoComplete="off"
            />
          </FormGroup>

          <hr />
          <FormGroup>
            <Label className="font-weight-bold d-block">TIZADO</Label>
            <Upload
              onRemove={(file) =>
                this.setState((prev) => ({
                  filelistTizado: (prev.filelistTizado || []).filter(
                    (f) => f.uid !== file.uid
                  ),
                }))
              }
              multiple
              onChange={this.handleChangeTizado}
              customRequest={this.customUploadTizado}
              fileList={filelistTizado}
              style={{ display: "block", textAlign: "left" }}
            >
              <Button icon={<Icon type="upload" />}> Subir Tizado</Button>
            </Upload>
          </FormGroup>

          <FormGroup style={{ marginTop: "15px" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={completado}
                onChange={this.toggleCompletado}
                style={{ width: "16px", height: "16px" }}
              />
              Completado
            </label>
          </FormGroup>

          <Alert
            type="info"
            showIcon
            message={
              <span>
                Marcar <strong>Completado</strong> pasa este color a{" "}
                <strong>Listo</strong> y crea automáticamente el registro en
                Costura. Sin marcarlo, queda en <strong>En Curso</strong> y
                puedes seguir editándolo más adelante. Una vez en{" "}
                <strong>Listo</strong>, para volver a editarlo vas a
                necesitar la contraseña.
              </span>
            }
            style={{ marginTop: "10px" }}
          />
        </form>
      </Modal>
    );
  }
}

export default CorteRegistroModal;
